import styled from "styled-components";
import { BodyDefault, BodyMedium } from "../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 50px 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 10px 16px 40px;
  }
`

export const PhoneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap:6px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 360px;
    min-width: 0;
  }

`

export const PageBody = styled.div`
  display:flex;
  justify-content:space-between;
  width: 100%;

  @media screen and (max-width: 768px) {
    min-width: 0;
    flex-direction: column;
    gap: 24px;
  }
`

export const RegionChoice = styled.div`
  box-sizing: border-box;
  width: min(100%, 760px);
  margin-top: 30px;
  padding: 24px;
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.card};

  @media screen and (max-width: 768px) {
    margin-top: 24px;
    padding: 20px 16px;
  }
`

export const RegionChoiceDescription = styled(BodyDefault)`
  max-width: 600px;
  margin-top: 8px;
  color: ${({theme}) => theme.palette[800]};
`

export const RegionCards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const RegionCard = styled.div<{$current:boolean}>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  padding: 20px;
  border: ${({theme, $current}) => `1px solid ${$current ? theme.accent[100] : theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  background-color: ${({theme}) => theme.grey[100]};
`

export const RegionCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const RegionFlag = styled.img`
  width: 32px;
  height: 24px;
  border-radius: 3px;
  object-fit: cover;
`

export const RegionStatus = styled.span<{$current:boolean}>`
  padding: 3px 8px;
  border-radius: ${({theme}) => theme.radius.xs};
  background-color: ${({theme, $current}) => $current ? theme.accent[15] : theme.palette[300]};
  color: ${({theme, $current}) => $current ? theme.accent[300] : theme.palette[800]};
  font-size: 12px;
  line-height: 16px;
`

export const RegionName = styled(BodyMedium)`
  margin-top: 16px;
  color: ${({theme}) => theme.palette[900]};
`

export const RegionCode = styled(BodyDefault)`
  margin-top: 2px;
  margin-bottom: 20px;
  color: ${({theme}) => theme.palette[800]};
`

export const RegionReloadNotice = styled(BodyDefault)`
  margin-top: 16px;
  color: ${({theme}) => theme.palette[800]};
`

export const Form = styled.div`
  display:flex;
  flex-direction: column;
  gap:20px;
  padding-top:30px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 404px;
    min-width: 0;

    > * {
      max-width: 100%;
    }
  }
`

export const Gift = styled.div`
  background-size: 100%;
  background-repeat: no-repeat;
  width: 240px;
  /* height: 208px; */
  box-sizing: border-box;
  padding:51px 0px 15px 0px;
`
export const AdditionalContainer = styled.div`
  background-color: ${({theme}) => theme.grey[100]};
  padding: 20px;
  gap: 20px;
  width: 404px;
  height: 304px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 404px;
    height: auto;
    min-height: 304px;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 10px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-wrap: wrap;
  }
`
export const GiftMoneyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  height: 40px;
  background-color:#FFFF;
  margin-left:15px;
  border-radius: 8px;
  margin-bottom:22px;
`
export const Money = styled(BodyMedium)`
  color:#4671F6;
`

export const GiftDesc = styled(BodyDefault)`
  color:#FFFF;
  background-color: ${({theme}) => theme.isDark ? theme.palette[600] : theme.primary[600]};
  border-radius: 8px;
  margin-top:40px;
  box-sizing: border-box;
  width:100%;
  padding:15px;
`
